export default "__VITE_ASSET__BVIYKg6s__"